import React, { useEffect, useState } from "react";
import {
  UilUsdCircle,
  UilMoneyInsert,
  UilPadlock,
} from "@iconscout/react-unicons";
import axios from "axios";

const Payment = () => {
  const userId = localStorage.getItem("id");
  const [walletBalance, setWalletBalance] = useState(null);
  const [cashback, setCashback] = useState("");
  const [iscashback, setiscashback] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_FAST_URL}/payment.php?userId=${userId}`,
          {
            method: "GET",
          }
        );

        const data = await response.json();
        if (data) {
          setWalletBalance(data);
        } else {
          console.error("Error fetching wallet balance:", data.error);
        }
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
      }
    };

    fetchData();

    // get cashback value
    axios
      .get(`${process.env.REACT_APP_FAST_URL}/settings.php?type=cashback`)
      .then((response) => {
        console.log(response);
        console.log(response.data.cashback);
        setCashback(response.data.cashback || 0);
        if (response.data.cashback > 0) {
          setiscashback(true);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [userId]);

  const handleSubmit = (e) => {
    const amount = e.target.amount.value;
    if (amount < 5 || amount > 300) {
      e.preventDefault();
      setError("Minimum 5$ and Maximum 300$ is allowed per topup");
    } else {
      setError("");
    }
  };

  return (
    <div className="flex w-full flex-col gap-2 md:flex-row px-16 py-16">
      <div className="my-2 rounded-3xl bg-gradient-to-b from-sky-300 to-purple-500 p-px">
          <div className="w-full p-2 shadow-2xl bg-white rounded-[calc(1.5rem-1px)]">
       
        <div
          className="p-2 max-w-xl mx-auto rounded-lg   "
          style={{ textAlign: "center" }}
        >
          <div className="mb-6 bg-white p-4 rounded-md shadow-md">
            <div className="text-3xl font-bold text-blue-500 mb-2">
              {walletBalance !== null ? `${walletBalance}$` : "Loading..."}
            </div>
            <div className="text-lg font-semibold text-gray-700">
              Current Balance
              {/* <UilUsdCircle className="inline-block ml-1 mb-1" /> */}
            </div>
          </div>
          {iscashback && (
            <div className="mb-4 text-green-600 font-semibold">
              Get {cashback}% cashback on recharge!
            </div>
          )}

          <form
            onSubmit={handleSubmit}
            action={`${process.env.REACT_APP_FAST_URL}/payment.php`}
            method="post"
            className="bg-white p-6 rounded-md shadow-md"
          >
            <div className="mb-4">
              <label
                className="block text-gray-600 mb-8"
                style={{ fontSize: "1.55rem" }}
              >
                Top up your wallet{" "}
                <UilMoneyInsert className="inline-block ml-1 mb-2" />
              </label>
              {/* <p className="text-sm text-gray-500 mb-8">
                        Choose the amount you want to add to your wallet and proceed securely. <UilPadlock className="inline-block " size='18px' />
                    </p> */}
              <div className="flex items-center">
                {/* <span className="text-lg font-semibold mr-2">Recharge:</span> */}
                <input
                  type="text"
                  name="amount"
                  placeholder="Enter amount"
                  className="p-2 border rounded-md focus:outline-none focus:border-blue-500 w-full transition duration-300 ease-in-out"
                  required
                  style={{
                    boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
                    // borderRadius: '0.375rem',
                    borderRadius: "40px",
                    paddingLeft: "4%",
                  }}
                />
              </div>
              <div className="text-red-500 mt-2">{error}</div>
              <input type="hidden" name="userId" value={userId} />
            </div>
            <button
              className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 w-full transition duration-300 ease-in-out"
              style={{
                borderRadius: "40px",
                background:
                  "linear-gradient(to bottom right, #267fbe, #73dff6)",
              }}
            >
              Proceed
            </button>
            <p className="text-sm text-gray-500 mt-5 mb-5">
              Choose the amount you want to add to your wallet and proceed
              securely.{" "}
              <UilPadlock className="inline-block mb-0.5" size="18px" />
            </p>
          </form>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Payment;
